import Splide from '@splidejs/splide';

/**
 * Set up the Products Block
 */
class ProductsBlock {

  constructor() {
    this.domref = {};
    this.init();
  }

  init() {
    this.domref = this.getDomRefs();
    this.events();
    this.showFirstTab();
    this.splideInit();
    this.domref.products.forEach(p => {
      p.addEventListener('click', e => {
        const item = e.target.closest('.products-block__product');
        location.href = item.dataset.link;
      })
    });
  }
  
  events() {
    this.domref.tabs.addEventListener('click', e => this.onTabClick(e));
    
  }
  
  /**
   * Assign DOM refs
   * @returns {object}
   */
  getDomRefs() {
    return {
      tabs: document.querySelector('.products-block__tabs'),
      tabbuttons: document.querySelectorAll('.products-block__tabs li'),
      tabpanels: document.querySelectorAll('.products-block__tab-panel'),
      tabpanel(id) {return document.querySelector(`.products-block__tab-panel--${id}`)},
      products: document.querySelectorAll('.products-block__product'),
    }
  }

  /**
   * Trigger and show the first tab. If there is only one tab, don't trigger it.
   * The only visible tab that always displays is the 'all' tab which redirects.
   */
  showFirstTab() {
    if (this.domref.tabbuttons.length > 1) {
      this.domref.tabbuttons[0].click();
    }
  }

  /**
   * Show appropriate Tab content when tab is clicked or on page load
   * @todo this is not DRY with other modules
   * @param {Event} e 
   */
  onTabClick(e) {
    const el = e.target;
    if (el.tagName === 'LI' && el.dataset) {
      // Highlight selected tab
      this.domref.tabbuttons.forEach(tb => {
        tb.classList.remove('selected');
      });
      el.classList.add('selected');
      this.domref.tabpanels.forEach(tp => {
        tp.classList.remove('products-block__tab-panel--show');
      });
      const currentPanel = this.domref.tabpanel(el.dataset.tab);
      currentPanel.classList.add('products-block__tab-panel--show');
    }
  }

  /**
   * One splide per tab
   * @todo destruct and rebuild splide on tab click?
   */
  splideInit() {
    this.domref.tabpanels.forEach((el) => {
      const splide = new Splide(el.querySelector('.splide'), {
        type: 'loop',
        perPage: 4,
        perMove: 1,
        arrows: true,
        autoplay: true,
        gap: '1.5rem',
        pagination: false,
        classes: {
          // Banner slider navigation classes
          arrows: 'splide__arrows product-slider__arrows',
          arrow: 'splide__arrow product-slider__arrow',
          prev: 'splide__arrow--prev product-slider__arrow--prev',
          next: 'splide__arrow--next product-slider__arrow--next',
        },
        breakpoints: {
          992: {
            perPage: 3
          },
          650: {
            perPage: 2
          },
          450: {
            perPage: 1
          }
        }
      });
      splide.mount();
    });
  }

}

export default ProductsBlock;